// extracted by mini-css-extract-plugin
export var fadeIn = "_fe-1";
export var modalContent = "_fe-3";
export var overlay = "_fe-0";
export var popoverContent = "_fe-2";
export var results = "_fe-5";
export var searchInputWrapper = "_fe-4";